import React, { useState } from 'react';
import './StudentDevelopmentProgram.css';
import PageHeader from "../about/PageHeader";
import Navbar from '../components/navbar';
import Footer from '../components/Footer';

// Helper function to extract Day and Month/Year for the UI
const parseDateString = (dateStr) => {
  const firstDate = dateStr.split(' to ')[0];
  const parts = firstDate.split('/');
  
  if (parts.length === 3) {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const day = parts[0];
    const month = months[parseInt(parts[1], 10) - 1];
    const year = parts[2];
    return { day, my: `${month} ${year}` };
  }
  return { day: '•', my: dateStr }; // Fallback
};

const PrePlacementTraining = () => {
  const [activeTab, setActiveTab] = useState("2023-24");
  
  const sdpData = [
    // 2023-24
    { year: "2023-24", date: "17/02/2024 to 29/06/2024", name: "Mr. Vinay Raikar", organization: "Campus Credential", program: "Pre-Placement Training Session", type: "Career Development" },
    { year: "2023-24", date: "22/08/2023 to 31/08/2023", name: "Mr. Vinay Raikar", organization: "Campus Credential", program: "Pre-Placement Training Session", type: "Career Development" },

    // 2021-22  
    { year: "2021-22", date: "13/06/2022 to 17/06/2022", name: "Mr. Vinay Raikar", organization: "Campus Credential", program: "Pre-Placement Training Session", type: "Career Development" },
    { year: "2021-22", date: "03/01/2022", name: "Ms. Vertika Chandra", organization: "Accenture", program: "Industry Expectations from Freshers", type: "Personal Development" },
    { year: "2021-22", date: "01/07/2021 to 06/07/2021", name: "Mr. Vinay Raikar", organization: "Campus Credential", program: "Pre-Placement Training Session", type: "Career Development" },

    // 2020-21
    { year: "2020-21", date: "17/10/2020", name: "Mr. Dhananjay Prajapati", organization: "Zeus Learning", program: "Industry Expectations from Freshers", type: "Personal Development" },
    { year: "2020-21", date: "17/10/2020", name: "Mr. Vijay Venkatraman", organization: "JP Morgan Chase and Co.", program: "Industry Expectations from Freshers", type: "Personal Development" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Ms. Aparna Kulkarni", organization: "Tata Communications", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Ms. Rekha Desai", organization: "Nelito Systems", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Arvind Prabhu", organization: "RaceNext", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Dr. Suresh Shan", organization: "Mahindra & Mahindra", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Akshay Shah", organization: "iWeb Technology Sol.", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Ms. Juveri Mukherjee", organization: "AurionPro", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Apurb Sinha", organization: "Invesco Ltd", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Viral Sangvi", organization: "Nomura India Pvt ltd", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Rakeshkumar Y", organization: "Nomura India Pvt ltd", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Abhay Naik", organization: "Elevate K-12", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Gaurav Singh", organization: "1 Pay", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Sandeep Singh", organization: "Mumbai Monorail", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Prashant Nair", organization: "Larsen & Toubro Info.", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Vighanesh Surve", organization: "Willis Towers Watson", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Vishaldeep Jain", organization: "Capgemini", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "17/08/2020 to 21/08/2020", name: "Mr. Nikunj Jakhotia", organization: "Accenture", program: "Mock Virtual Interview Sessions", type: "Tech Session" },
    { year: "2020-21", date: "14/08/2020", name: "Ms. Kanupriya Manchanda", organization: "InfoBeans", program: "Virtual Interviews – What You Need to Know", type: "Career Development" },
    { year: "2020-21", date: "14/08/2020", name: "Mr. Sunil ManSingh", organization: "FactFinder", program: "Virtual Interviews – What You Need to Know", type: "Career Development" },
    { year: "2020-21", date: "07/07/2020", name: "Mr. Sanket Prabhu", organization: "The Turnover Tribe", program: "LinkedIn for Job Seekers: Get Noticed, Get Hired", type: "Career Development" },

    // 2019-20
    { year: "2019-20", date: "15/06/2020 to 03/10/2020", name: "Mr. Apurb Sinha", organization: "Invesco Ltd", program: "Salesforce Training", type: "Tech Session" },

    // 2018-19
    { year: "2018-19", date: "16/03/2019 to 30/06/2019", name: "Mr. Vinay Raikar", organization: "Campus Credential", program: "Pre-Placement Training Programme", type: "Career Development" },

    // 2017-18
    { year: "2017-18", date: "24/02/2018 to 30/06/2018", name: "Mr. Vinay Raikar", organization: "Campus Credential", program: "Aptitude, CV Building, Group Discussion and Personal Interview", type: "Career Development" }
  ];

  const years = [...new Set(sdpData.map(item => item.year))].sort((a, b) => b.localeCompare(a));
  const filteredData = sdpData.filter(item => item.year === activeTab);

  // Helper to assign CSS badge classes based on type
  const getBadgeClass = (type) => {
    switch (type) {
      case 'Career Development': return 'badge-career-development';
      case 'Tech Session': return 'badge-tech-session';
      case 'Personal Development': return 'badge-personal-development';
      default: return 'badge-default';
    }
  };

  const getIconBgClass = (type) => {
    switch (type) {
      case 'Career Development': return 'badge-bg-career-development icon-color-career-development';
      case 'Tech Session': return 'badge-bg-tech-session icon-color-tech-session';
      case 'Personal Development': return 'badge-bg-personal-development icon-color-personal-development';
      default: return 'badge-bg-default icon-color-default';
    }
  };

  return (
    <>
      <Navbar />
      <div className="sdprog-page-wrapper">
        <PageHeader
          title="Pre-Placement Training"
          crumbs={[{ label: "Home", href: "/" }, { label: "Pre-Placement Training" }]}
        />

        <div className="sdprog-main-container">
          {/* Year Tabs */}
          <div className="sdprog-controls">
            <div className="sdprog-year-tabs">
              {years.map(year => (
                <div
                  key={year}
                  className={`sdprog-year-tab ${activeTab === year ? 'sdprog-year-tab-active' : ''}`}
                  onClick={() => setActiveTab(year)}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>

          {/* Year Info Header */}
          <div className="sdprog-year-info">
            <div className="sdprog-info-left">
              <div className="sdprog-accent-bar"></div>
              <div>
                <h2 className="sdprog-year-heading">Academic Year {activeTab}</h2>
                <div className="sdprog-year-stats">
                  <span>{filteredData.length} Programs</span> | 
                  <span> {filteredData.filter(d => d.type === "Tech Session").length} Tech Sessions</span>
                </div>
              </div>
            </div>
          </div>

          {/* Timeline Section */}
          <div className="sdprog-list-section">
            {filteredData.map((item, idx) => {
              const { day, my } = parseDateString(item.date);
              
              return (
                <div key={idx} className="sdprog-timeline-row">
                  
                  {/* Left Column: Date & Timeline Line */}
                  <div className="sdprog-date-col">
                    <div className="sdprog-date-day">{day}</div>
                    <div className="sdprog-date-my">{my}</div>
                    {item.date.includes('to') && (
                      <div className="sdprog-date-weekday">Range</div>
                    )}
                    <div className="sdprog-timeline-divider">
                      <div className="sdprog-timeline-dot"></div>
                    </div>
                  </div>

                  {/* Right Column: Program Card */}
                  <div className="sdprog-program-card">
                    {/* Icon */}
                    <div className={`sdprog-card-icon ${getIconBgClass(item.type)}`}>
                      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                      </svg>
                    </div>
                    
                    {/* Content */}
                    <div className="sdprog-program-content">
                      <div className="sdprog-program-title">{item.program}</div>
                      <div className="sdprog-program-speaker">By {item.name}</div>
                      <div className="sdprog-program-org">{item.organization}</div>
                    </div>

                    {/* Actions & Badge */}
                    <div className="sdprog-card-actions">
                      <div className={`sdprog-category-badge ${getBadgeClass(item.type)}`}>
                         {item.type || 'General Session'}
                      </div>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrePlacementTraining;